<script setup>
import { associazionePage } from '@/graphql/queries/associazione.js'

definePageMeta({
  layout: 'default',
})

const { locale } = useI18n()

const variables = computed(() => ({
  locale: locale.value,
}))

const { data } = await useGraphql(associazionePage, variables)

if (!data.value.paginaAssociazione) {
  throw createError({ statusCode: 404 })
}

const page = computed(() => data?.value?.paginaAssociazione || {})

const seo = computed(() => page?.value?.seo || {})

useSeo(seo)
</script>

<template>
  <div class="associazione-page">
    <div class="p-top-xxl-2 row-400-25-default max-content">
      <LazyTitleDoubleColText :block="page.intro" type="custom-position" />
      <LazyTitleDoubleColText
        :block="page.sezioneDoppiaColonna1"
        type="custom-position"
      />
    </div>
    <LazySwiperSlider
      v-if="page.carosello && page.carosello.length"
      :slides="page.carosello"
      type="default-type"
      class="p-top-xl-1 p-bottom-xl-1"
    />
    <div class="p-top-xl-1">
      <div
        :style="{ backgroundColor: page.preFooter.coloreSfondo.hex }"
        style="z-index: 1"
      >
        <LazyTitleDoubleColText
          class="row-400-25-default max-content"
          :block="page.preFooter.contenuto"
          type="default"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssociazionePage',
}
</script>
